import { useEffect, useRef } from "react";

const poly = (ctx, w, h, pts) => {
  ctx.beginPath();
  ctx.moveTo(pts[0][0] * w, pts[0][1] * h);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0] * w, pts[i][1] * h);
  ctx.closePath();
  ctx.fill();
};

const drawFigure = (o, w, h) => {
  o.fillStyle = "#fff";
  o.beginPath();
  o.ellipse(w * 0.5, h * 0.115, h * 0.062, h * 0.075, 0, 0, Math.PI * 2);
  o.fill();
  poly(o, w, h, [[0.46, 0.17], [0.54, 0.17], [0.54, 0.245], [0.46, 0.245]]);
  poly(o, w, h, [[0.34, 0.235], [0.66, 0.235], [0.62, 0.58], [0.38, 0.58]]);
  poly(o, w, h, [[0.34, 0.245], [0.30, 0.255], [0.26, 0.53], [0.305, 0.545], [0.36, 0.32]]);
  poly(o, w, h, [[0.66, 0.245], [0.70, 0.255], [0.74, 0.53], [0.695, 0.545], [0.64, 0.32]]);
  poly(o, w, h, [[0.38, 0.58], [0.49, 0.60], [0.475, 0.955], [0.405, 0.955]]);
  poly(o, w, h, [[0.51, 0.60], [0.62, 0.58], [0.595, 0.955], [0.525, 0.955]]);
};

const TwinSilhouette = ({ className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let dots = [];

    const build = () => {
      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      if (!w || !h) return;
      const dpr = window.devicePixelRatio || 1;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const off = document.createElement("canvas");
      off.width = w;
      off.height = h;
      const o = off.getContext("2d");
      drawFigure(o, w, h);
      const img = o.getImageData(0, 0, w, h).data;
      const step = Math.max(3, Math.round(h / 42));
      dots = [];
      for (let y = 0; y < h; y += step) {
        for (let x = 0; x < w; x += step) {
          if (img[(y * w + x) * 4 + 3] > 120) {
            dots.push({
              x: x + (Math.random() - 0.5) * step * 0.8,
              y: y + (Math.random() - 0.5) * step * 0.8,
              r: 0.6 + Math.random() * 1.1,
              base: 0.12 + Math.random() * 0.42,
              ph: Math.random() * Math.PI * 2,
              sp: 0.4 + Math.random() * 1.3,
            });
          }
        }
      }
    };

    const loop = (t) => {
      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      ctx.clearRect(0, 0, w, h);
      for (const d of dots) {
        const a = d.base * (0.5 + 0.5 * Math.sin((t / 1000) * d.sp + d.ph));
        ctx.fillStyle = `rgba(210, 55, 139, ${Math.max(0.05, a)})`;
        ctx.beginPath();
        ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(loop);
    };

    build();
    raf = requestAnimationFrame(loop);
    const ro = new ResizeObserver(build);
    ro.observe(canvas);
    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
  }, []);

  return <canvas ref={ref} className={className} data-testid="twin-silhouette" />;
};

export default TwinSilhouette;
